/* global System */
// register component(s) with react habitat

export default { Anchors: () => System.import('./index') }
